import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 140px);
  background-color: #ffffff;
  overflow-y: hidden;

  @media(max-width: 770px) {
    height: 100vh;
  }
`;

export const GridStatus = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
`;

export const Content = styled.div`
  overflow-y: scroll;
  height: 95%;
  width: 100%;

  @media(max-width: 770px) {
    height: 80%;
  }
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: -10px;
  padding: 0px 1rem;

  @media (min-width: 500px) {
    padding: 0px 4rem;
  }

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;

  @media (min-width: 500px) {
    margin-top: 0.7rem;
  }
`;

export const OrderIcon = styled.img`
  margin: -0.1rem 0.7rem 0 0;
  width: 18%;

  @media (min-width: 768px) {
    width: 10%;
    margin-top: 0.7rem;
  }

  @media (min-width: 1024px) {
    width: 7%;
    margin-top: 0.7rem;
  }
`;

export const ContainerItems = styled.div`
  margin-top: 2rem;
`;

export const ContainerDesktop = styled.div`
  display: flex;
`;

export const ContainerStatus = styled.div`
  @media (min-width: 768px) {
    margin: 0.7rem 0 0 0;
  }
`;

export const DateTitle = styled.span`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    margin-right: 1rem;
  }

  span {
    display: none;
    color: #969696;
    font-size: 0.8rem;

    @media (min-width: 768px) {
      display: block;
    }
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    display: none
  }
`;

export const HeaderMobileContainer = styled.div`
  @media (min-width: 770px) {
    display: none
  }
`;

export const IconLoading = styled.i`
  font-size: 16px;
  color: #000FFF;
`;

export const StatusCollor = styled.div`
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 2rem;
  margin: 0.2rem 0.3rem 0 0;
  background-color: ${(props) => {
    if (
      props.status === "AGUARDANDO ANÁLISE DO FINANCEIRO" ||
      props.status === "EM ANÁLISE PELO FINANCEIRO" ||
      props.status ===
        "AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO" ||
      props.status ===
        "AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO"
    ) {
      return `#000FFF`;
    } else if (props.status === "LIBERADO") {
      return `#00E309`;
    } else if (props.status === "NÃO LIBERADO PELO FINANCEIRO") {
      return `#F7D100`;
    } else {
      return `#FD0000`;
    }
  }};
`;
